"use client"

import { useEffect, useState } from "react"
import { buildFallback, fetchPrices, type PriceData } from "@/lib/pricing"

/**
 * Live Stripe prices for client components that render a price but weren't
 * handed `PriceData` from their server page (navbar, homepage, go/* clients).
 * Seeds synchronously with the country fallback so first paint already shows
 * the right currency/amount, then swaps in the live feed. `/api/prices` is
 * CDN- + fetch-cached, so the swap is cheap and shared across the session.
 *
 * Mirrors the inline pattern in `components/ui/blood-test-card.tsx`.
 */
export function useLivePrices(country: string): PriceData {
  const [prices, setPrices] = useState<PriceData>(() => buildFallback(country))
  useEffect(() => {
    let live = true
    fetchPrices(country).then((p) => {
      if (live) setPrices(p)
    })
    return () => {
      live = false
    }
  }, [country])
  return prices
}
